import * as React from "react";
import {
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles,
    Zoom
} from "@material-ui/core";
import { formatAuctionDateTime } from "../../../helpers/auctionDateTime";
import { IParcelBid } from "../../../models/parcel/IParcelBid";
import { Numbers } from "../../../models/utility/Numbers";
import * as ParcelBidNodeCss from "../../../styles/ParcelBidNodeCss";
import ParcelBidTimeline from "./ParcelBidTimeline";

type IProps = WithStyles<typeof styles | typeof ParcelBidNodeCss.styles> & {
    bid: IParcelBid;
    bidPosition: ParcelBidNodeCss.TimelinePosition;
    isCurrentUser: boolean;
    isFirstBid?: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        ...ParcelBidNodeCss.styles(theme),
        bidBlockTopStacked: {
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "flex-end"
        },
        bidTimeWrapper: { whiteSpace: "nowrap" },
        circleBid: {
            [theme.breakpoints.down("xs")]: {
                height: 17,
                width: 17
            },
            backgroundColor: "#C0C0C0",
            borderRadius: "50%",
            height: 20,
            position: "relative",
            width: 20
        },
        circleBidStart: { backgroundColor: theme.palette.success.light },
        circleBidUser: {
            [theme.breakpoints.down("xs")]: {
                height: 30,
                width: 30
            },
            backgroundColor: theme.palette.success.light,
            borderRadius: "50%",
            height: 35,
            position: "relative",
            width: 35
        }
    });

class ParcelBidHistoryNode extends React.PureComponent<IProps, {}> {
    public render() {
        const { bid, bidPosition, classes, isCurrentUser, isFirstBid } =
            this.props;

        let bidClassCircle = classes.circleBid;
        if (isCurrentUser) bidClassCircle = classes.circleBidUser;
        else if (isFirstBid) bidClassCircle += ` ${classes.circleBidStart}`;
        const bidClassText = isCurrentUser
            ? classes.textBidUser
            : classes.textBid;
        const textClasses = `${classes.textBase} ${bidClassText}`;
        const startingBidTextClasses = `${classes.textBase} ${
            isCurrentUser ? classes.textBidUser : classes.auctionStartText
        }`;
        const bidReceivedTime = formatAuctionDateTime(bid.bidReceivedTime);

        return (
            <Zoom in={true}>
                <div className={classes.bidNodeWrapper}>
                    <ParcelBidTimeline
                        classes={classes}
                        position={bidPosition}
                    />

                    <div
                        className={`${classes.bidBlockTop} ${
                            isFirstBid ? classes.bidBlockTopStacked : ""
                        }`}
                    >
                        {isFirstBid && (
                            <>
                                <Typography
                                    className={`${startingBidTextClasses} ${classes.textTop}`}
                                    component="div"
                                    variant="button"
                                >
                                    Starting Bid
                                </Typography>
                                <Typography
                                    className={`${startingBidTextClasses} ${classes.textBidAmount}`}
                                    component="div"
                                    variant="caption"
                                >
                                    Received
                                </Typography>
                            </>
                        )}
                        {isCurrentUser && (
                            <Typography
                                className={`${textClasses} ${classes.textTop}`}
                                component="div"
                                variant="button"
                            >
                                Your Bid
                            </Typography>
                        )}
                    </div>
                    <div className={classes.bidBlockMiddle}>
                        <div className={bidClassCircle} />
                    </div>
                    <div className={classes.bidBlockBottom}>
                        <div className={classes.bidTimeWrapper}>
                            <Typography
                                className={`${classes.textTime} ${textClasses}`}
                                component="span"
                                variant="button"
                                display="inline"
                            >
                                {bidReceivedTime?.clockTime}
                            </Typography>
                            <Typography
                                className={`${classes.textBidAmount} ${textClasses}`}
                                component="span"
                                variant="caption"
                                display="inline"
                            >
                                {bidReceivedTime?.dayPeriod}
                            </Typography>
                        </div>

                        <Typography
                            className={`${classes.textBidAmount} ${textClasses}`}
                            component="div"
                            variant="caption"
                        >
                            {Numbers.toShortFormat(bid.bidAmount)}
                        </Typography>
                    </div>
                </div>
            </Zoom>
        );
    }
}

export default withStyles(styles)(ParcelBidHistoryNode);
